import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("produlimp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatARS = (n) => {
  try {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    }).format(n || 0);
  } catch {
    return `$ ${Math.round(n || 0)}`;
  }
};

export const formatApiError = (detail) => {
  if (!detail) return "Algo salió mal. Intentá de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};

export const NEW_PRODUCT_DAYS = 15;

export const isNewProduct = (product) => {
  const t = Date.parse(product?.created_at || "");
  return Number.isFinite(t) && Date.now() - t < NEW_PRODUCT_DAYS * 24 * 60 * 60 * 1000;
};
